import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import driverImg from "../assets/driverImg.png";
import api from "../api";
import aquilaLogo from "../assets/aquilaLogo.svg";
import { format, parseISO } from "date-fns";

export default function ConfirmRide() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [ride, setRide] = useState(null);
  const [error, setError] = useState(""); // Estado para errores
  const [fieldErrors, setFieldErrors] = useState({});

  const [successMessage, setSuccessMessage] = useState("");

  function formatHourToAmPm(hourString) {
    const [hours, minutes] = hourString.split(":").map(Number);
    const period = hours >= 12 ? "p.m." : "a.m.";
    const formattedHour = hours % 12 || 12; // Convierte 0 a 12 para formato AM/PM
    return `${formattedHour}:${String(minutes).padStart(2, "0")} ${period}`;
  }

  useEffect(() => {
    async function fetchDriver() {
      try {
        const rideDetails = await api.rides.getOne(token);
        setRide(rideDetails);
        console.log(ride);
        setError("");
      } catch (error) {
        console.error("Error fetching driver details:", error);
        setError("Error al obtener los detalles del conductor.");
      }
    }
    fetchDriver();
  }, [token]);

  const handleFormSubmit = async (event, type) => {
    event.preventDefault();
    setError(null);
    setFieldErrors({});

    const data = {
      token: token,
      status: type === "rechazar" ? 6 : 4,
    };

    try {
      await api.rides.updateStatus(data);
      setSuccessMessage(
        type === "rechazar"
          ? "Has rechazado el viaje."
          : "Has confirmado el viaje."
      );
    } catch (error) {
      if (error.message) {
        // Ajuste para errores específicos de campo según la estructura proporcionada
        const fieldErrors = error.message;
        setFieldErrors(fieldErrors);
      } else {
        setError("Error. Intenta nuevamente.");
      }
    }
  };

  return (
    <div className="poppins-medium flex flex-col justify-center items-center h-screen bg-[#F8F9FB] w-full p-8">
      <img
        className="w-[78px] mb-[60px] ml-auto mr-auto"
        src={aquilaLogo}
        alt="Logo de Aquila"
      />
      {successMessage ? (
        <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
          <h3 className="text-xl text-[#595A5C]">{successMessage}</h3>
        </div>
      ) : (
        <div className="flex flex-col gap-10 pt-[35px] pb-[18px] md:p-[50px] rounded-2xl bg-white md:w-[763px]">
          <div className="flex flex-col gap-2">
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            {fieldErrors.detail && (
              <p className="text-red-500 text-sm text-center">
                {fieldErrors.detail}
              </p>
            )}
            <h3 className="text-xl text-center text-[#595A5C]">
              Confirmación del viaje
            </h3>

            {/*<p className="poppins-regular text-center text-xs text-[#8F99A6]">
            Aquí puedes confirmar o rechazar un viaje
          </p>*/}
          </div>

          <div className="grid grid-cols-2 gap-4 p-4 md:bg-[#FAFAFA] rounded-md tracking-wider">
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Nombre del cliente</span>
              <span className="text-[#282828] text-[10px]">
                {ride?.client?.name}
              </span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">
                Teléfono del pasajero
              </span>
              <span className="text-[#282828] text-[10px]">
                {ride?.passengerContact}
              </span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Fecha & Hora</span>
              <span className="text-[#282828] text-[10px]">
                {ride &&
                  format(parseISO(ride?.date), "dd/MM/yyyy") +
                    " | " +
                    formatHourToAmPm(ride?.hour)}
              </span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Lugar de recogida</span>
              <span className="text-[#282828] text-[10px]">{ride?.pickup}</span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Lugar de destino</span>
              <span className="text-[#282828] text-[10px]">
                {ride?.destination}
              </span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Conductor asignado</span>
              <span className="text-[#282828] text-[10px]">
                {ride?.driver?.name}
              </span>
            </div>
            <div className="flex flex-col p-4">
              <span className="text-[#8F99A6] text-xs">Vehículo Asignado</span>
              <span className="text-[#282828] text-[10px]">
                {ride?.vehicle?.name}
              </span>
            </div>
            <div className="flex flex-col p-4 w-full">
              <span className="text-[#8F99A6] text-xs">Observaciones</span>
              <span className="text-[#282828] text-[10px] break-words">
                {ride?.observations}
              </span>
            </div>
          </div>

          <div className="flex justify-center w-full gap-20">
            <button
              onClick={(e) => handleFormSubmit(e, "rechazar")}
              className="text-[#E66672] text-xs py-4 px-4 rounded-2xl tracking-wider"
            >
              Rechazar
            </button>
            <button
              onClick={(e) => handleFormSubmit(e, "confirmar")}
              className="bg-[#D1FADF] w-[177px] text-[#004122] border-[0.3px] border-[#004122] text-xs py-4 px-4 rounded-2xl tracking-wider"
            >
              Confirmar viaje
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
